import "./style.scss"
import { useDispatch } from "react-redux"
import { incrementByAmount } from "../../store/Header";
import { useEffect } from "react";
import EadlineCom from "../../components/EadlineCom";
import { Swiper, SwiperSlide } from 'swiper/react';
import { Navigation, Pagination, EffectCreative } from "swiper/modules";
import 'swiper/css';
import 'swiper/css/navigation';
import 'swiper/css/pagination';
import { useState, useRef } from "react";
import { getBlogsListAPI } from "../../api";
import swiper from "swiper"
import { Carousel } from 'antd';
import BlogCom from "../../components/BlogCom";
import { LeftOutlined, RightOutlined } from '@ant-design/icons';
import ChatCom from "../../components/ChatCom";
import { courseDeta, courseDeta2, courseDeta3, parentsList, teacherDataList } from "./config.js";
const SingaporePage = () => {
    const dispatch = useDispatch()
    const swiperRef = useRef(null);
    const carouselRef = useRef(null);
    const [blogList, setBlogList] = useState(null);
    let isTrue = false;
    const handleNextSlide = () => {
        swiperRef.current.swiper.slideNext();
    };
    useEffect(() => {
        dispatch(incrementByAmount(5));
        getBlogsListAPI({ type: '2', page: 1, limit: 10 }).then((res) => {
            setBlogList(res);
        })
        if (isTrue === false) {
            isTrue = true;
            const scriptDiv3 = document.createElement('script');
            scriptDiv3.innerHTML = `!function (w, d, t) {
  w.TiktokAnalyticsObject=t;var ttq=w[t]=w[t]||[];ttq.methods=["page","track","identify","instances","debug","on","off","once","ready","alias","group","enableCookie","disableCookie","holdConsent","revokeConsent","grantConsent"],ttq.setAndDefer=function(t,e){t[e]=function(){t.push([e].concat(Array.prototype.slice.call(arguments,0)))}};for(var i=0;i<ttq.methods.length;i++)ttq.setAndDefer(ttq,ttq.methods[i]);ttq.instance=function(t){for(
var e=ttq._i[t]||[],n=0;n<ttq.methods.length;n++)ttq.setAndDefer(e,ttq.methods[n]);return e},ttq.load=function(e,n){var r="https://analytics.tiktok.com/i18n/pixel/events.js",o=n&&n.partner;ttq._i=ttq._i||{},ttq._i[e]=[],ttq._i[e]._u=r,ttq._t=ttq._t||{},ttq._t[e]=+new Date,ttq._o=ttq._o||{},ttq._o[e]=n||{};n=document.createElement("script")
;n.type="text/javascript",n.async=!0,n.src=r+"?sdkid="+e+"&lib="+t;e=document.getElementsByTagName("script")[0];e.parentNode.insertBefore(n,e)};
  ttq.load('CV4HIRRC77U90MOBDB9G');
  ttq.page();
}(window, document, 'ttq');`;
            document.head.appendChild(scriptDiv3);
            document.title = '新加坡K2-S3华文数学英文补习课程';
        }
        new swiper('.swiper', {
            spaceBetween: 0, //slide之间距——间距30
            centeredSlides: false, // 多列居中显示
            effect: 'fade',
            fadeEffect: {
                crossFade: true,
            }, //fade属性必须加上
            navigation: {
                nextEl: ".swiper-next",
                prevEl: ".swiper-prev",
            },
            pagination: {
                el: ".swiper-pagination",
            },
        });
        setTimeout(() => {
            handleNextSlide()
        }, 500);

    }, [])
    const smallTitleCom = (data) => {
        return (<div className="smallTitle" ><span className="round"></span>{data}</div>)
    }
    const teachersCom = (item, index) => {
        return (
            <div className="teacherItem" key={index}>
                <div className="imgBag teacherBag3" style={{ backgroundImage: `url(${item.picture})` }}>
                    <div className="teacherContent">{item.introduce}
                    </div>
                </div>
                <div className="teacherDetails">
                    <span className="teacherName">{item.name}</span>
                    <span className="teacherLife">{item.teacherLife}</span>
                </div>
                <div className="line"></div>
                <div className="teacherWord">
                    {item.introduce}
                </div>
                <div className="icon">
                    <div className="iconBox">
                        <img src="../assets/singapore/class22.png" alt="" /><span
                        >{item.quality}</span
                        >
                    </div>
                    <div className="iconBox">
                        <img src="../assets/singapore/class11.png" alt="" /><span
                        >{item.remark}</span
                        >
                    </div>
                </div>
            </div>
        );
    };
    return (
        <div className="singaporePage" >
            <div className="singaporeHeader"><img src='../assets/singapore/singaporeBg.png' alt="" />
                <div className="name">Singapore</div>
            </div>
            <EadlineCom name={"Sino-Bus Online Chinese Course"} />
            <div className="subheading">Sino-Bus Offering The Following Online Chinese Classes </div>
            <div className="courseMol typeArea" >
                <div className="courseImg"><img src='../assets/singapore/course1.jpg' alt="" /></div>
                <div className="right">
                    <div className="rightTitle">
                        <span className="round"></span>PreSchool (For Age 3-5)
                    </div>
                    {
                        courseDeta.map((item, index) => {
                            return <div key={index}> <div className="word1">Main Content: </div>
                                <div className="word2">Online Chinese Lesson content includes pinyin and literacy. Help children Learn Chinese Characters and phonics in preschool. And the basic cognition of Chinese characters.</div></div>
                        })
                    }
                </div>
            </div>
            <div> {smallTitleCom('SG Primary School (For Age 7-12)')}
                <div className="copywriting typeArea"> Based on the "欢乐伙伴" series of textbooks issued by the Ministry   </div>
                <div className="schoolBox typeArea">
                    {
                        courseDeta2.map((item, index) => {
                            return <div className="schoolItem" key={index}>
                                <div className="schoolItemLeft" style={{ backgroundColor: item.bagColor, color: item.color }}>{item.number}</div>
                                <div className="schoolItemRight">{item.content}</div>
                            </div>
                        })
                    }
                </div></div>
            <EadlineCom name={"Why Sino-bus?"} />
            <div className="reasonBox typeArea">
                {courseDeta3.map((item, index) => {
                    return (
                        <div className="reasonItem" key={index}>
                            <div className="reasonImg">
                                <img src={item.picture} alt="" />
                            </div>
                            <div className="reasonWord">{item.title}</div>
                        </div>
                    )
                })}
            </div>
            <div className="swiperMod">
                <div className="leftIcon" onClick={() => { carouselRef.current.prev() }}><LeftOutlined /> </div>
                <div style={{ width: "80%" }}>
                    <div>
                        <Carousel effect="fade" ref={carouselRef}>
                            {parentsList?.map((item, index) => (
                                <div key={index}>
                                    <div>
                                        <div className="parentsModule typeArea">
                                            <div className="mob"> <EadlineCom name={item.introduce} /></div>
                                            <div className="parentsImg"><img className="" src={item.picture} alt="" /></div>
                                            <div className="parentsWord">
                                                <div className="pc">
                                                    <EadlineCom name={item.introduce} />
                                                </div>
                                                <div className="parentsInfo">
                                                    <img className="comma" src="../assets/singapore/comma.png" alt="" />
                                                    <span className="studentFeedback">{item.message}</span
                                                    >
                                                </div>
                                                <div className="parentsName">{item.name}</div>
                                                <div className="years">{item.age}</div>
                                            </div>
                                        </div>
                                    </div>
                                </div>

                            ))}
                        </Carousel>
                    </div>
                </div>
                <div className="rightIcon" onClick={() => { carouselRef.current.next() }}>
                    <RightOutlined />
                </div>
            </div>
            <div className="teacherBox">
                <EadlineCom name={"Sino-Bus Professional Tutor"} />
                <div className="teachersPc">
                    <div className="teachers   typeArea">
                        {
                            teacherDataList?.map((item, index) => {
                                return teachersCom(item, index);
                            })
                        }

                    </div>
                </div>
                <div className="teachersMob">
                    <div className="teachers">
                        <Swiper
                            loop={true} //设置循环轮播
                            autoplay={{ disableOnteraction: false }}
                            slidesPerView="1" //设置显示的数量
                            navigation={true} //modules上加了同时要设置为true，才显示
                            modules={[Navigation, Pagination, EffectCreative]}
                            grabCursor={true}
                            pagination={{ clickable: true }}
                            ref={swiperRef}
                            creativeEffect={{
                                prev: {

                                },
                                next: {
                                },
                            }}
                        >
                            {teacherDataList?.map((item, index) => (
                                <SwiperSlide key={index} style={{ width: "100%", transform: (0, 0, 0), height: "auto" }}>
                                    {
                                        teachersCom(item, index)
                                    }
                                </SwiperSlide>))}
                        </Swiper>

                    </div>

                </div></div>
            <EadlineCom name="Blog" />
            {
                blogList != null ? <BlogCom data='2' blogLists={blogList} /> : null
            }
            <EadlineCom name={"It's as easy as 3 steps"} />
            <div className="flowPath typeArea">
                <div className="flowPath1 flowPathItem">
                    <img className="stepImg" src="../assets/singapore/step1.png" alt="" />
                    <p className="stepTitle">Sign up/Login</p>
                    <p className="stepContent">Register in Email or Login your account now</p>
                </div>
                <div className="arrow">{">>"}</div>
                <div className="flowPath2 flowPathItem">
                    <img className="stepImg" src="../assets/singapore/step2.png" alt="" />
                    <p className="stepTitle">Chat Contact</p>
                    <p className="stepContent">We’ll contact you by WhatsApp for your needs</p>
                </div>
                <div className="arrow">{">>"}</div>
                <div className="flowPath3 flowPathItem">
                    <img className="stepImg" src="../assets/singapore/step3.png" alt="" />
                    <p className="stepTitle">Trial Class</p>
                    <p className="stepContent">Our Class Arranging teacher will add you and rrange a suitable teacher for your trial
                        class!</p>
                </div>
            </div>
            <ChatCom url='https://wa.me/8618165329059?text=%E5%8D%8E%E6%96%87%E5%92%A8%E8%AF%A2' text="限时抢免费试听" />
        </div >
    )
}
export default SingaporePage;